// /src/pages/private/admin/PrivateDocuments/donatePanel/donatePanelApi.js

import axios from 'axios';

export async function fetchDonatePanelAdmin() {
  const res = await axios.get('/api/admin/privatedocuments/donate-panel', { withCredentials: true });
  return res.data;
}

export async function saveDonatePanel(payload) {
  const res = await axios.put('/api/admin/privatedocuments/donate-panel', payload, { withCredentials: true });
  return res.data;
}

export async function uploadDonatePanelBanner(file) {
  const formData = new FormData();
  formData.append('file', file);
  const res = await axios.post('/api/admin/privatedocuments/donate-panel/banner', formData, {
    withCredentials: true,
  });
  return res.data;
}

export async function deleteDonatePanelBanner() {
  const res = await axios.delete('/api/admin/privatedocuments/donate-panel/banner', { withCredentials: true });
  return res.data;
}

export async function fetchDonatePanelPublic() {
  const res = await axios.get('/api/public/donate-panel');
  return res.data;
}

export async function createKofiDonationIntent() {
  const res = await axios.post('/api/kofi/donation-intent', {}, { withCredentials: true });
  return res.data;
}

export async function fetchKofiMySubscription() {
  const res = await axios.get('/api/kofi/my-subscription', { withCredentials: true });
  return res.data;
}

export async function fetchKofiMySupportStatus() {
  const res = await axios.get('/api/kofi/my-support-status', { withCredentials: true });
  return res.data;
}

export async function confirmKofiMySupportChoice(level) {
  const res = await axios.post('/api/kofi/my-support-choice', { level }, { withCredentials: true });
  return res.data;
}
